import React, { useState, useEffect, useMemo, useCallback, useRef, useContext } from 'react';
import dayjs from 'dayjs';
import { Download, Share, ContentCopy, TaskAltOutlined, ScheduleOutlined } from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';
import Label from 'components/label/Label';
import CircularProgress from '@mui/material/CircularProgress';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { getAllReplicas, revokeInterpretationRequest, getEcgReportAndData, getReportInterpretaionStatus, getReplicaInterpretationData } from 'api/reports';
import { copyToClipboard, downloadFromURI } from 'utils/Utils';

import LoadingButton from '@mui/lab/LoadingButton';
import { List, ListItem, ListItemText, Dialog, DialogTitle, DialogContent, DialogActions, Box, Chip, Link, FormControl, FormControlLabel, InputLabel, Select, MenuItem, Grid, Stack, Typography, Tooltip, Button, TableCell, Switch } from '@mui/material';
import useResponsive from '../hooks/useResponsive';
import { useSnackbar } from '../components/snackbar'
import { styled } from '@mui/material/styles';
import { Document, Page } from "react-pdf";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useAuthDispatch } from 'components/AuthStateProvider';
import customStyle from '../customstyle.module.css';
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";


//------------------------------------Data Grid-------------------------//

import {
    DataGrid,
    GridToolbarExport,
    GridToolbarContainer,
    GridToolbarQuickFilter,
    GridToolbarFilterButton,
    GridToolbarColumnsButton,
} from '@mui/x-data-grid';
//import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

//-----------------------------------------------------------------------
const OverflowTypography = styled(Typography)((maxWidth) => ({
    maxWidth: `${maxWidth}px`, // percentage also works
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
}));

export default function AllEcgReports() {
    const documentRef = useRef(null);
    const { enqueueSnackbar } = useSnackbar();
    const { socket, getSocketValue } = useAuthDispatch()
    const isSmall = useResponsive('', 'xs');
    const isMd = useResponsive('between', 'xs', 'md');
    const isLg = useResponsive('up', 'md');
    const { account } = useAuthDispatch();
    const { searchStartstatus, searchStartDate, searchEndDate, searchResults } = JSON.parse(window.sessionStorage.getItem("searchInterpretationDetails") || '{}');
    const [page, setPage] = useState(0);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [filterName, setFilterName] = useState('');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState([]);
    const [rows, setRows] = useState([]);
    const [filteredRows, setFilteredRows] = useState([]);
    const [dataCount, setDataCount] = useState(null);
    const [status, setstatus] = useState(searchStartstatus || "all");
    const [loading, setLoading] = useState(true);
    const [startDate, setStartDate] = useState(searchStartDate ? dayjs(searchStartDate) : dayjs());
    const [endDate, setEndDate] = useState(searchEndDate ? dayjs(searchEndDate) : dayjs());
    const [rowLoading, setRowLoading] = useState(null);
    const [socketUsed, setSocketUsed] = useState(false);

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState(null);

    const [selectionModel, setSelectionModel] = useState([]);
    const [sortModel, setSortModel] = useState([]);
    const [pdf, setPdf] = useState(null);
    const [pdfScale, setPdfScale] = useState(isLg || isMd ? 1 : 0.5);
    const [openViewPdfDialog, setOpenViewPdfDialog] = useState(false);
    const [rowId, setRowId] = useState(null)
    const [openLink, setopenLink] = useState(false);

    const [totalPages, setTotalPages] = useState(0);
    const [pdfData, setPdfData] = useState();
    const [interpretationStatusFilter, setInterpretationStatusFilter] = useState('all');

    // for alert pop up 
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertUser, setAlertUser] = useState('');
    const [showReferredOnly, setShowReferredOnly] = useState(
        account?.userType === "lead-expert" || account?.userType === "doctor"
    );

    // ---------------------------------------
    // Format Report Type for Dialog Box
    // Removes REPORT, underscores, fixes casing
    // ---------------------------------------
    const formatReportType = (type) => {
        if (!type) return "--";
        return type
            .replace("REPORT", "")
            .replace(/_/g, " ")
            .trim()
            .toLowerCase()
            .replace(/\b\w/g, (c) => c.toUpperCase());
    };

    const handleZoom = (scale) => {
        setPdfScale(scale <= 1 ? (isLg ? 1 : 0.5) : scale)
    };
    const dialogStyles = {
        overflow: 'hidden', // Remove scroll bar
        padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center',
        height: '100vh'
    };


    const navigate = useNavigate();

    const TABLE_HEAD = useMemo(() => [
        {
            field: 'searchname', headerName: 'Name', width: status === 'completed' ? 240 : 250, align: 'left', renderCell: (params) => (
                <>
                    <Grid>
                        <Grid>
                            {params.row.name}
                        </Grid>
                        {/* <Grid>
              {params?.row?.subsDetails && (
                <div>
                  <Chip
                    label={`${params?.row?.subsDetailstype} - ${params?.row?.subsDetails}`}
                    size="small"
                    color={params?.row?.subsDetailstype?.toLowerCase() === "paid" ? 'success' : 'warning'}
                    sx={{ marginLeft: 4, fontSize: '10px', marginBottom: .5, padding: 0, height: 'auto', textTransform: 'capitalize' }}
                  />
                </div>
              )}
            </Grid> */}
                        <Grid>
                            {(params?.row?.subsDetails || params?.row?.payment) && (
                                <div>
                                    <Chip
                                        label={
                                            params?.row?.subsDetails ? `${params?.row?.subsDetailstype} - ${params?.row?.subsDetails}${params?.row?.payment?.payment_id ? `, Paid - ${params?.row?.payment?.payment_id}` : ''}` : `Paid - ${params?.row?.payment?.payment_id}`
                                        }
                                        size="small"
                                        color={
                                            params?.row?.subsDetails
                                                ? (params?.row?.subsDetailstype?.toLowerCase() === "paid" ? 'success' : 'warning')
                                                : (params?.row?.payment?.payment_id ? 'success' : 'warning')
                                        }
                                        sx={{
                                            marginLeft: 4,
                                            fontSize: '10px',
                                            marginBottom: .5,
                                            padding: 0,
                                            height: 'auto',
                                            textTransform: 'capitalize'
                                        }}
                                    />
                                </div>
                            )}
                        </Grid>
                    </Grid>
                </>
            )
            , filterable: true
        },
        { field: "searchid", headerName: "Report ID", width: 100, hide: true },
        { field: 'searchreportType', headerName: 'Report Type', width: status === 'completed' ? 120 : 150, align: 'left', renderCell: (params) => params.row.reportType, filterable: true, hide: true },
        {
            field: 'searchdevicetype',
            headerName: 'Device Type',
            width: 170,
            align: 'left',
            renderCell: (params) => (
                <>
                    <Grid>
                        <Grid>
                            {params.row.device_type}
                        </Grid>
                        {/* <Grid>
              <div>
                <Chip
                  label={params.row.reportType}
                  size="small"
                  color={ 'success' }
                  sx={{ marginLeft: 4, fontSize: '10px', marginBottom: .5, padding:0, height: 'auto', textTransform: 'capitalize' }}
                />
              </div>
            </Grid> */}
                    </Grid>
                </>
            ), // This uses the device_type field directly, not params.row.deviceparams?.row?.device_type,
            filterable: true,
        },

        {
            field: 'searchtakenAt', headerName: 'Taken At', width: status === 'completed' ? 120 : 130, align: 'left', hide: true, renderCell: (params) => params.row?.takenAt, filterable: true, sortComparator: (v1, v2, param1, param2) => {
                return new Date(v1) - new Date(v2);
            },
        },
        {
            field: 'searchrequestedAt', headerName: 'Requested At', width: status === 'completed' ? 130 : 150, align: 'left', hide: true, renderCell: (params) => params.row?.requestedAt, filterable: true, sortComparator: (v1, v2, param1, param2) => {
                return new Date(v1) - new Date(v2);
            },
        },
        ...(status === 'completed' || status === '' ? [{
            field: 'searchcompletedAt', headerName: 'Completed At', width: 130, align: 'left', renderCell: (params) => params.row?.completedAt, filterable: true, sortComparator: (v1, v2, param1, param2) => {
                return new Date(v1) - new Date(v2);
            },
        }] : []),
        ...(status === 'completed' || status === '' ? [{ field: 'searchfindings', headerName: 'Findings', width: 100, align: 'left', filterable: true, renderCell: (params) => params.row.findings_status }] : []),
        {
            field: 'leadTraceStatus',
            headerName: 'Lead Trace',
            width: 100,
            align: 'center',
            sortable: false,
            filterable: true,
            renderCell: (params) => {
                const isDone = params?.row?.leadTrace;

                return (
                    <Typography
                        variant="subtitle2"
                        sx={{
                            fontWeight: 600,
                            color: isDone ? 'success.main' : 'warning.main',
                        }}
                    >
                        {isDone ? 'Done' : 'Pending'}
                    </Typography>
                );
            },
        },
        { field: 'searchbusinessname', headerName: 'Business Name', width: 120, align: 'left', renderCell: (params) => params.row?.business_name || '--', filterable: false, hide: true },
        { field: 'searchecg_status', headerName: 'Status', width: status === 'completed' ? 160 : 200, align: 'left', renderCell: (params) => params.row?.ecg_status, filterable: true, sortable: false },
        { field: 'action', headerName: 'Action', width: status === 'completed' ? 180 : 200, align: 'left', renderCell: (params) => params.row?.action, sortable: false },


    ]);
    const styles = {
        documentBlock: {
            // maxWidth: 800,
            margin: "0px",
            marginTop: 5,
            // border: "1px solid #999",
            display: "flex",
            width: "100%",
            justifyContent: "center",
            height: "80vh",
            overflow: "auto",
        },
    }

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    function applySortFilter(array, comparator, query) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0)
                return order;
            return a[1] - b[1];
        });
        if (query) {
            return array.filter((_user) =>
                _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
            );
        }
        return stabilizedThis.map((el) => el[0]);
    }

    const isDateRangeValid = (start, end) => {
        if (!start || !end) return true;
        return dayjs(end).diff(dayjs(start), "day") <= 3;
    };


    const handleStartDateChange = (date) => {
        if (!date) return;

        const newStart = dayjs(date);
        if (endDate && dayjs(endDate).isBefore(newStart, "day")) {
            enqueueSnackbar("End date cannot be earlier than start date.", {
                variant: "warning",
            });
            setStartDate(newStart);
            return;
        }
        if (endDate && !isDateRangeValid(newStart, endDate)) {
            enqueueSnackbar("You can view data for a maximum of 3 days only.", {
                variant: "warning",
            });
            setStartDate(newStart);
            return;
        }

        setStartDate(newStart);
        setLoading(true);
    };



    const handleEndDateChange = (date) => {
        if (!date) return;

        const today = dayjs();
        const newEnd = dayjs(date).isAfter(today) ? today : dayjs(date);


        if (startDate && newEnd.isBefore(dayjs(startDate), "day")) {
            enqueueSnackbar("End date cannot be earlier than start date.", {
                variant: "warning",
            });
            setEndDate(newEnd);
            return;
        }

        if (startDate && !isDateRangeValid(startDate, newEnd)) {
            enqueueSnackbar("You can view data for a maximum of 3 days only.", {
                variant: "warning",
            });
            setEndDate(newEnd);
            return;
        }

        setEndDate(newEnd);
        setLoading(true);
    };

    



    const metaData = selectedRowData?.meta_data ? JSON.parse(selectedRowData.meta_data) : {};

    useEffect(() => {

        const socketVal = async () => {
            await getSocketValue();
        }

        if (socket) {

            //  socket.on('addReport', (result) => {

            //    if (result && result?.length) {

            //      let filteredData
            //      if (showReferredOnly) {
            //        result = result.filter(r =>
            //          r?.referred_to === account?.userType ||
            //          r?.referred_by?.userType === account?.userType
            //        );
            //      }

            //      filteredData = result.filter(item => !data.some(dt => item?.id == dt?.id));

            //      setData(prevData => [...filteredData, ...prevData])
            //      setRows(prevData => [...filteredData.map(item => { return mapRowData({ ...item, isNew: true }) }), ...prevData])
            //    }
            //  })

            socket.on('InterpretationInProgress', (resultData) => {
                if (resultData) {
                    setData((prevItems) => prevItems.map((item) => {
                        return item.id == resultData?.id ? { ...item, ...resultData } : item
                    }))
                    setRows((prevItems) => prevItems.map((item) => {
                        return item.id == resultData?.id ? mapRowData({ ...item, ...resultData, selected: true }) : item
                    }));
                }

            })
        }
        else {
            socketVal();
        }
    }, [socketUsed])






    useEffect(() => {
        if (!startDate || !endDate) return;

        if (
            dayjs(endDate).isBefore(dayjs(startDate), "day") ||
            !isDateRangeValid(startDate, endDate)
        ) {
            setLoading(false);
            return;
        }

        fetchData();
    }, [status, startDate, endDate, showReferredOnly]);


    useEffect(() => {
        if (interpretationStatusFilter === "all") return setFilteredRows([]);
        setFilteredRows(rows?.filter(item => item?.searchfindings === interpretationStatusFilter))
    }, [interpretationStatusFilter]);

    const fetchData = async () => {

        try {
            // Normal reports
            const response = await getAllReplicas({
                startDate: formatDate(startDate),
                endDate: formatDate(endDate),
                status: status,
                interpretedWithoutRequest: true
            });

            let computedCounts = response?.counts
            setLoading(false);
            if (response && response?.success) {
                let reports = response?.data

                // If toggle ON → filter only referred reports
                if (showReferredOnly) {


                    reports = reports.filter(r =>
                        r?.referred_to === account?.userType ||
                        r?.referred_by?.userType === account?.userType
                    );

                    computedCounts = {
                        totalRequested: reports.filter(r => r.interpretation_request_status === "requested").length,
                        totalInprogress: reports.filter(r => r.interpretation_request_status === "interpretation in progress").length,
                        totalCompleted: reports.filter(r => r.interpretation_request_status === "completed").length,
                    };
                }


                const filteredData = reports.filter(row =>
                    !row.interpretation_request_status
                    || row.interpretation_request_status === "requested"
                    || row.interpretation_request_status === "interpretation in progress"
                    || row.interpretation_request_status === "completed"
                );

                const mappedData = filteredData?.map(row => {
                    return {
                        ...row,
                        // inside fetchData mapping when constructing mappedData:
                        interpretation_data_logs: row?.interpretation_completed_at
                            ? [{
                                interpreter_details: row.interpreter_details,
                                completed_at: parseInt(row.interpretation_completed_at, 10),
                                // make sure to include whichever matrix exists on the row
                                ecg_quality_matrix: row?.interpretation_data?.ecg_quality_matrix ?? row?.ecg_quality_matrix ?? null,
                                // also include alternate-named matrix if present (keeps compatibility)
                                ecg_trac_matrix: row?.interpretation_data?.ecg_trac_matrix ?? row?.ecg_trac_matrix ?? null
                            }, ...(row?.interpretation_data_logs || [])]
                            : (row?.interpretation_data_logs || [])

                    }
                });

                setData(mappedData || []);
                setDataCount(computedCounts);
                sortingData(mappedData || []);
                const searchDetails = {
                    searchStartstatus: status,
                    searchStartDate: startDate,
                    searchEndDate: endDate,
                    searchResults: mappedData
                };
                window.sessionStorage.setItem("searchInterpretationDetails", JSON.stringify(searchDetails));

            } else {
                if (response) {
                    enqueueSnackbar(response.message, { variant: 'error' })
                }
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setLoading(false);
        }
    };
    const formatDate = (date) => {
        return date ? dayjs(date).format('DD MMM, YYYY') : null;
    };

    function sortingData(reportData) {
        //--------------------------------------------//
        let filteredUsers;
        if (status === "completed" || status === "") {
            filteredUsers = applySortFilter(
                reportData.filter(row => {
                    if (interpretationStatusFilter === 'all') {
                        return true;
                    } else {
                        return row?.interpretation_report_status === interpretationStatusFilter;
                    }
                }),
                getComparator(order, orderBy),
                filterName
            );
        } else {
            filteredUsers = applySortFilter(reportData, getComparator(order, orderBy), filterName);
        }

        const dataRows = filteredUsers.map((row, index) => {
            return mapRowData(row);
        });
        setRows(dataRows)
    }





    const mapRowData = (row) => {
        const isSPUL = row?.meta_data ? JSON.parse(row?.meta_data)?.device_id?.startsWith("SPUL") : false;

        // helper to safely read lead-trace status from several possible locations
        // improved helper — place near top of file or in utils


        return {
            searchdevicetype: row?.meta_data ? JSON.parse(row?.meta_data)?.device_name : '',
            searchbusinessname: row?.business_name,
            id: `${row?.id}`,
            searchname: `${row?.user_data?.first_name} ${row?.user_data?.last_name}, ${row?.user_data?.phone_number}`,
            searchid: String(row?.id),
            searchreportType: `${row?.report_type?.replace(/REPORT|_/g, ' ')}`,
            searchfindings: row?.interpretation_report_status,
            searchecg_status: row?.interpretation_request_status,
            searchtakenAt: row?.report_timestamp ? parseInt(row?.report_timestamp) : '',
            searchrequestedAt: row?.interpretation_requested_at ? parseInt(row?.interpretation_requested_at) : '',
            searchcompletedAt: row?.interpretation_completed_at ? parseInt(row?.interpretation_completed_at) : '',
            name: (
                <TableCell sx={{ border: 'unset' }} component="div" scope="row" padding="none">
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <ContentCopy fontSize='small' sx={{ cursor: "pointer" }} onClick={onCopyClick(row?.user_data?.phone_number)} />
                        <Tooltip title={row?.user_data?.phone_number}>
                            <OverflowTypography maxWidth={150} variant="subtitle2" noWrap>
                                {row?.user_data?.first_name} {row?.user_data?.last_name}
                            </OverflowTypography>
                        </Tooltip>
                    </Stack>
                </TableCell>
            ),
            // business_name: row?.business_name ? (
            //     <TableCell sx={{ border: 'unset' }} component="div" scope="row" padding="none">
            //         <Tooltip title={row?.user_data?.business_name}>
            //             <OverflowTypography maxWidth={150} variant="subtitle2" noWrap>
            //                 {row?.business_name}
            //             </OverflowTypography>
            //         </Tooltip>
            //     </TableCell>
            // ) : '',
            device_type: (
                <TableCell sx={{ border: 'unset' }} component="div" scope="row" padding="none">
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <Box sx={{ m: 1, position: 'relative' }}>
                            <PictureAsPdfIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={(e) => onlyViewPdf(e, row)} />
                        </Box>
                        <OverflowTypography maxWidth={150} variant="subtitle2" noWrap>
                            {row?.meta_data && JSON.parse(row?.meta_data)?.device_name ? JSON.parse(row?.meta_data)?.device_name : ''}
                        </OverflowTypography>
                    </Stack>
                </TableCell>
            ),
            reportType: (
                <TableCell sx={{ border: 'unset' }} component="div" scope="row" padding="none">
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <Box sx={{ m: 1, position: 'relative' }}>
                            <PictureAsPdfIcon fontSize='small' sx={{ cursor: "pointer" }} onClick={(e) => onlyViewPdf(e, row)} />
                        </Box>
                        <OverflowTypography maxWidth={150} variant="subtitle2" noWrap>
                            {row?.report_type?.replace(/REPORT|_/g, ' ')}
                        </OverflowTypography>
                    </Stack>
                </TableCell>
            ),
            // removed fancy "is same day" logic per your earlier asks — keep only timestamp formatting elsewhere if needed
            takenAt: '', // if you're replacing takenAt with leadTrace, keep blank or remove column mapping
            requestedAt: <Tooltip title={(row?.interpretation_requested_at ? dayjs(parseInt(row?.interpretation_requested_at)).format('DD MMM, YYYY hh:mm A') : '--')}>
                <span>{(row?.interpretation_requested_at ? dayjs(parseInt(row?.interpretation_requested_at)).format('DD MMM hh:mm A') : '--')}</span>
            </Tooltip>,
            completedAt: <Tooltip title={(row?.interpretation_completed_at ? dayjs(parseInt(row?.interpretation_completed_at)).format('DD MMM, YYYY hh:mm A') : '--')}>
                <span>{(row?.interpretation_completed_at ? dayjs(parseInt(row?.interpretation_completed_at)).format('DD MMM hh:mm A') : '--')}</span>
            </Tooltip>,
            findings_status: status === "completed" || !status ? (
                <Typography color={row?.interpretation_report_status === 'normal' ? 'success.main' :
                    row?.interpretation_report_status === 'abnormal' ? 'warning.main' :
                        row?.interpretation_report_status === 'critical' ? 'error.main' :
                            row?.interpretation_report_status === 'retake' ? 'info.main' : 'default'}>
                    {row?.interpretation_report_status === 'normal' ? 'Normal' :
                        row?.interpretation_report_status === 'abnormal' ? 'Abnormal' :
                            row?.interpretation_report_status === 'critical' ? 'Critical' :
                                row?.interpretation_report_status === 'retake' ? 'Retake' : ' '}
                </Typography>
            ) : null,
            ecg_status:
                (row?.selected || row?.interpretation_request_status === "interpretation in progress") ? (
                    <Tooltip title="In progress">
                        <Label color="warning">
                            <ScheduleOutlined sx={{ mr: 1 }} fontSize="small" />
                            <OverflowTypography maxWidth={100} variant="subtitle2" noWrap>
                                {row?.interpreter_details?.name
                                    ? `By: ${row.interpreter_details.name}`
                                    : row?.referred_to
                                        ? `To: ${row.referred_to}`
                                        : "In progress"}
                            </OverflowTypography>
                        </Label>
                    </Tooltip>
                ) : row?.interpretation_request_status === "completed" ? (
                    <Tooltip title="Interpreted">
                        <Label color="success">
                            <TaskAltOutlined sx={{ mr: 1 }} fontSize="small" />
                            <OverflowTypography maxWidth={100} variant="subtitle2" noWrap>
                                {`By: ${row?.interpreter_details?.name || "-"}`}
                            </OverflowTypography>
                        </Label>
                    </Tooltip>
                ) : (
                    <Tooltip title="New request">
                        <Label color="primary">
                            {row?.interpretation_request_status || "To Interpret"}
                        </Label>
                    </Tooltip>
                ),

            action: row?.interpretation_request_status === "interpretation in progress" ? (
                //  ( row?.interpreter_phone_number === account?.phoneNumber  )? (
                //     <>
                //       <LoadingButton
                //         loading={(row?.id === rowLoading)}
                //         aria-describedby="adadsa"
                //         variant="contained"
                //         color='warning'
                //         onClick={handleRevokeRequest(row?.id)}
                //       >
                //         Revoke
                //       </LoadingButton>
                //       <Button
                //         sx={{ ml: 2 }}
                //         aria-describedby="adadsa"
                //         variant="contained"
                //         onClick={(event) => handleAction(event, row, 'delete')}
                //       >
                //         Edit
                //       </Button>
                //     </>
                //   ) :((row.referred_to?.some(ref => ref.api_key === account?.id)) ?(): ("--"))
                (row?.interpreter_phone_number === account?.phoneNumber) ? (
                    <>
                        <LoadingButton
                            loading={row?.id === rowLoading}
                            aria-describedby="adadsa"
                            variant="contained"
                            color="warning"
                            onClick={handleRevokeRequest(row?.id)}
                        >
                            Revoke
                        </LoadingButton>

                        <Button
                            sx={{ ml: 2 }}
                            aria-describedby="adadsa"
                            variant="contained"
                            onClick={(event) => handleAction(event, row, "delete")}
                        >
                            Edit
                        </Button>
                    </>
                ) : (row?.referred_to === account?.userType) ? (
                    <Button
                        aria-describedby="adadsa"
                        variant="contained"
                        onClick={(event) => handleAction(event, row, 'delete')}
                        disabled={row?.selected || !row?.user_data?.first_name}
                    >
                        Interpret
                    </Button>
                ) : (
                    "--"
                )

            ) : row?.interpretation_request_status === 'completed' && dayjs(row?.interpretation_completed_at).isBefore(dayjs().subtract(1, 'minute')) ? (
                <>
                    <Button
                        aria-describedby="adadsa"
                        variant="contained"
                        onClick={(event) => handleAction(event, row, 'delete')}
                    >
                        Edit
                    </Button>
                    <Tooltip
                        sx={{ ml: 2 }} title="Download" arrow>
                        <LoadingButton
                            variant="contained"
                            onClick={(event) => downloadPDF(event, row, 'download')}
                        >
                            <Download />
                        </LoadingButton>
                    </Tooltip>
                </>
            )
                : (
                    <Button
                        aria-describedby="adadsa"
                        variant="contained"
                        onClick={(event) => handleAction(event, row, 'delete')}
                        disabled={row?.selected || !row?.user_data?.first_name}
                    >
                        {row?.interpretation_request_status === "completed" ? "Edit" : "Interpret"}
                    </Button>
                ),
            report_status: row?.interpretation_request_status,
            phone_number: row?.interpreter_phone_number,
            user_data: row?.user_data,
            interpreter_details: row?.interpreter_details,
            selected: row?.selected,
            rowsData: row,
            isNew: row?.isNew,
            isSPUL,
            subsDetails: row?.subscription_details?.plan_name,
            subsDetailstype: row?.subscription_details?.subscription_type,
            payment: row?.payment,
            leadTrace: row?.leadTrace
        };
    }; // <-- important: close mapRowData with semicolon


    //--------------------------------------------//


    useEffect(() => {
        if (!socket) return;
    }, [socket]);
    useEffect(() => {
        if (!socket || !account?.authorization) return;

        const onConnect = () => {
            socket.emit("event", {
                authToken: account.authorization,
                socketId: socket.id,
            });
        };

        if (socket.connected) {
            onConnect();
        } else {
            socket.once("connect", onConnect);
        }

        return () => {
            socket.off("connect", onConnect);
        };
    }, [socket, account?.authorization]);



    const handleAction = async (e, row, type) => {

        e.stopPropagation();
        const reportStatus = await getReportInterpretaionStatus(row?.id)
       

        if (reportStatus.data.state === "interpretation in progress" && row.referred_to != account.userType && row.interpreter_phone_number !== account.phoneNumber) {
            setAlertUser(reportStatus.data.interpreter_name);
            setAlertOpen(true);
            // remove locally so it disappears immediately
            setData(prevItems => prevItems.filter(item => item.id != row.id));
            setRows(prevItems => prevItems.filter(item => item.id != row.id));
            return;
        }
        if (socket && (row.interpretation_request_status !== "completed" && row.interpretation_request_status !== "interpretation in progress")) {
            const interPretedWithoutReq = true;
            socket.emit('onClickInterpret', row?.id, account?.authorization, interPretedWithoutReq)
            setSocketUsed(prev => !prev)
        }
        navigate(`${process.env.REACT_APP_HOMEPAGE}custominterpretation/${row.id}?replica=true&leadTrace=false`);

    };


    const downloadPDF = async (e, row) => {
        e.stopPropagation();
        const id = row?.id;
        setRowLoading(id);
        try {
            const reportresponse = await getReplicaInterpretationData({ id, replicadata: true });;
            const reportdata = reportresponse?.data;

            const fileName = `${reportdata?.user_data?.first_name}-${reportdata?.user_data?.last_name}-${dayjs(reportdata?.report_timestamp).format('DD-MM-YYYY-HH-mm')}${reportdata?.interpretation_data?.report_status ? `-${reportdata?.interpretation_data?.report_status}` : ''}`;
            downloadFromURI(`data:application/pdf;base64,${reportdata?.ReportPdf}`, fileName)
            setRowLoading(null);
            enqueueSnackbar("Pdf download suceessfully", { variant: 'success' })
        } catch (error) {
            enqueueSnackbar(error, { variant: 'error' })
        }
    };


    const onlyViewPdf = async (e, row) => {
        try {
            e.stopPropagation();
            const id = row?.id
            setRowId(id);

            if (row?.interpretation_request_status == 'requested') {
                getEcgReportAndData({
                    id
                }).then(reportData => {
                    const fetchedPdfData = reportData?.data?.ReportPdf
                    if (!fetchedPdfData) {
                        setOpenViewPdfDialog(false)
                        enqueueSnackbar("Some error occurred while fetching pdf", { variant: 'error' })
                    } else {
                        const URL = `data:application/pdf;base64,${fetchedPdfData}`;
                        setPdfData(reportData?.data)
                        setPdf(URL);
                    }
                })
            } else {
                setopenLink(true)
                getReplicaInterpretationData({ id, replicadata: true }).then(reportData => {
                    const fetchedPdfData = reportData?.data?.ReportPdf
                    if (!fetchedPdfData) {
                        setOpenViewPdfDialog(false)
                        enqueueSnackbar("Some error occurred while fetching pdf", { variant: 'error' })
                    } else {
                        const URL = `data:application/pdf;base64,${fetchedPdfData}`;
                        setPdfData(reportData?.data)
                        setPdf(URL);
                    }

                })
            }
            setOpenViewPdfDialog(true)
        } catch (error) {
            enqueueSnackbar(error, { variant: 'error' })
        }
    }

    const handleStatus = (newStatus) => {
        setInterpretationStatusFilter("all")
        if (status === newStatus) {
            setstatus('all');
            setLoading(true);
        } else {
            setstatus(newStatus);
            setLoading(true);
        }
    };

    const onCopyClick = (text) => (e) => {
        e.stopPropagation();
        copyToClipboard(text);
        enqueueSnackbar("Copied to clipboard.", { variant: 'success' })
    };

    const handleChange = (event) => {
        setLoading(true);
        setInterpretationStatusFilter(event.target.value);
        setLoading(false);
    };

    const handleRevokeRequest = (id) => async (e) => {
        e.stopPropagation();
        setRowLoading(id);
        const interpretationWR = true;
        const response = await revokeInterpretationRequest({ ids: [id], interpretationWR })
        if (response?.success) {
            setRowLoading(null);
            setData([...data.filter(item => item?.id !== id)])
            fetchData();
            enqueueSnackbar(response.message, { variant: 'success' })
        } else {
            enqueueSnackbar(response.message, { variant: 'error' })
            setRowLoading(null);
        }
    };

    const StyledBox = styled(Box)({
        '.highlightRow': {
            backgroundColor: '#FFEEBA',
        },
    });

    function NoRowsOverlay() {
        return (
            <Stack height="100%" alignItems="center" justifyContent="center">
                No rows in DataGrid
                <pre>(rows=&#123;[]&#125;)</pre>
            </Stack>
        );
    }

    const handleCloseDialog = useCallback(() => {
        setSelectedRowData(null);
        setIsDialogOpen(false);

    });

    const handleOpenDialog = (rowId, event) => {
        event.preventDefault();
        const rowData = data?.find(item => item?.id == rowId);
        if (rowData?.interpretation_completed_at || rowData?.interpretation_requested_at) {
            setSelectedRowData(rowData);
            setIsDialogOpen(true);
        }
    };

    const handleSortModalChange = (model) => {
        setSortModel(model)
    }
    const handleCloseViewPdfDialog = () => {
        setOpenViewPdfDialog(false);
        setPdf(null);
        setopenLink(false)

    }

    const downloadAppPdf = async () => {

        try {

            const reportResponse = await getEcgReportAndData({
                id: rowId
            })

            if (!reportResponse || reportResponse.status === 400) {
                throw new Error('Failed to fetch report data');
            }
            const reportData = reportResponse?.data;
            const fetchedPdfData = reportData?.ReportPdf;

            const uri = `data:application/pdf;base64,${fetchedPdfData}`;
            const fileName = `ecg-report-${reportData?.user_data?.first_name}${reportData?.user_data?.last_name ? `-${reportData?.user_data?.last_name}` : ''}-${dayjs(reportData?.report_timestamp).format('DD-MM-YYYY-HH-mm')}${reportData?.interpretation_data?.report_status ? `-${reportData?.interpretation_data?.report_status}` : ''}.pdf`;
            downloadFromURI(uri, fileName)
            enqueueSnackbar("Pdf downloading successfully", { variant: 'success' })

        }
        catch (error) {
            enqueueSnackbar(error, { variant: 'error' })

        }

    }

    const downloadDefaultPdf = () => {
        try {
            if (pdfData) {
                const fileName = `ecg-report-${pdfData?.user_data?.first_name}${pdfData?.user_data?.last_name ? `-${pdfData?.user_data?.last_name}` : ''}-${dayjs(pdfData?.report_timestamp).format('DD-MM-YYYY-HH-mm')}${pdfData?.interpretation_data?.report_status ? `-${pdfData?.interpretation_data?.report_status}` : ''}.pdf`;
                downloadFromURI(pdf, fileName)
            }
        }
        catch (e) {
            enqueueSnackbar(error, { variant: 'error' })

        }
    }


    return (
        <>
            <StyledBox >
                <Grid sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginY: '10px',
                    marginBottom: '20px',
                    px: 1,
                    flexDirection: (isSmall ? 'column-reverse' : 'row'),
                    gap: (isSmall ? '1rem' : 0)
                }}>

                    <Grid item xs={12} md={6}>
                        {(account?.userType === "lead-expert" || account?.userType === "doctor") && (
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={showReferredOnly}
                                        onChange={(e) => {
                                            setShowReferredOnly(e.target.checked);
                                            setLoading(true); // ensure loader shows
                                        }}
                                    />
                                }
                                label="Referred Reports"
                            />
                        )}

                        <Box flexDirection="column" gap={2} display="flex" flexWrap="wrap" alignItems="left">
                            {/* {dataCount && <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
                <Typography variant="div" sx={{ marginBottom: 0 }} color="#2065D1" gutterBottom>
                  Requested: <b>{dataCount?.totalRequested || 0}</b>
                </Typography> |
                <Typography variant="div" sx={{ marginBottom: 0 }} color="green" gutterBottom>
                  Completed: <b>{dataCount?.totalCompleted || 0}</b>
                </Typography> |
                <Typography variant="div" sx={{ marginBottom: 0, fontWeight: 500 }} color="#FFC107" gutterBottom>
                  In-Progress: <b>{dataCount?.totalInprogress || 0}</b>
                </Typography>
              </Stack>} */}
                            {/* <Stack direction="row" alignItems="center" justifyContent="flex-start" gap={1}>
                                <Typography variant="div" sx={{ fontWeight: 600 }} color="primary">
                                    Total: <b>{rows?.length || 0}</b>
                                </Typography>
                            </Stack> */}
                            <Box flexDirection="column" gap={2} display="flex" flexWrap="wrap" alignItems="center">

                                <Stack direction="row" spacing={1}>
                                    <Chip
                                        label={`To Interpret`}
                                        onClick={() => handleStatus('requested')}
                                        color="primary"
                                        variant={status === 'requested' ? "filled" : "outlined"}
                                    />
                                    <Chip
                                        label={`Completed`}
                                        onClick={() => handleStatus('completed')}
                                        color="success"
                                        variant={status === 'completed' ? "filled" : "outlined"}
                                    />
                                    <Chip
                                        label={`In Progress`}
                                        onClick={() => handleStatus('interpretation in progress')}
                                        color="warning"
                                        variant={status === 'interpretation in progress' ? "filled" : "outlined"}
                                    />
                                </Stack>
                            </Box>

                        </Box>
                    </Grid>
                    <Grid item xs={12} md={5}>
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                            }} >
                            <Stack direction="row" spacing={1}>
                                <DatePicker
                                    sx={{ width: (isSmall ? '120px' : (isMd ? '120px' : '150px')) }}
                                    label="Start Date"
                                    value={startDate}
                                    format='DD/MM/YYYY'
                                    maxDate={dayjs()}
                                    onChange={(date) => handleStartDateChange(date)}
                                />
                                <DatePicker
                                    sx={{ width: (isSmall ? '120px' : (isMd ? '120px' : '150px')) }}
                                    label="End Date"
                                    value={endDate}
                                    format='DD/MM/YYYY'
                                    minDate={startDate}
                                    maxDate={dayjs()}
                                    onChange={(date) => handleEndDateChange(date)}
                                />
                            </Stack>
                        </Box>
                    </Grid>
                </Grid>
            </StyledBox>
            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'end', marginTop: '30px' }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box sx={!data ? { height: '100%', width: '100%' } : {}}>
                    <DataGrid autoHeight={true}
                        sx={{ m: 1, p: 1 }}
                        // rows={filteredRows?.length ? filteredRows : rows}
                        rows={rows}
                        filterMode="client"
                        columns={TABLE_HEAD}
                        disableVirtualization={true}
                        getRowId={(row) => row?.id}
                        getRowClicked={(row) => row?.id}
                        onRowClick={(row, event) => handleOpenDialog(row?.id, event)}
                        selectionModel={selectionModel}
                        onSelectionModelChange={(newSelectionModel) => {
                            setSelectionModel(newSelectionModel);
                        }}
                        getRowClassName={(params) => {
                            // const isSelected = params.row.selected;
                            // const isTrue = params.row.isNew;
                            // let isSPUL = params?.row?.rowsData?.meta_data ? JSON.parse(params?.row?.rowsData?.meta_data)?.device_id?.startsWith("SPUL") : false;
                            return params.row?.isNew ? customStyle?.highlightRowNew : params.row?.selected ? customStyle?.highlightRowProgress : "";
                        }}
                        localeText={{ noRowsLabel: 'No interpretation request found.' }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10,
                                },
                            },
                            columns: {
                                columnVisibilityModel: {
                                    searchid: false,
                                    searchreportType: false,
                                    searchtakenAt: false,
                                    searchrequestedAt: false,
                                    searchbusinessname: false

                                },
                            },

                        }}
                        hideFooter={!rows?.length}
                        pageSizeOptions={[10, 15, 20, 25]}
                        slots={{
                            toolbar: () => (
                                <>
                                    <GridToolbarContainer>
                                        <GridToolbarQuickFilter
                                            getApplyQuickFilterFn={(filterValue) => {
                                                if (!filterValue) return null;
                                                const s = filterValue.toLowerCase();

                                                return ({ row }) =>
                                                    String(row?.searchid || "")
                                                        .toLowerCase()
                                                        .includes(s) ||
                                                    row?.searchname?.toLowerCase().includes(s) ||
                                                    // row?.searchbusinessname?.toLowerCase().includes(s) ||
                                                    row?.searchdevicetype?.toLowerCase().includes(s) ||
                                                    row?.searchreportType?.toLowerCase().includes(s);
                                            }}
                                        />

                                        <Stack
                                            spacing={3}
                                            flexGrow={1}
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="flex-end"
                                        >
                                            <GridToolbarColumnsButton />
                                            <GridToolbarFilterButton />
                                            <GridToolbarExport csvOptions={{ fields: ["searchname", "searchreportType", "searchtakenAt", "searchrequestedAt", "searchfindings", "searchecg_status"] }} />
                                        </Stack>
                                    </GridToolbarContainer>
                                </>
                            ),
                        }}
                        sortModel={sortModel}
                        onSortModelChange={(model) => handleSortModalChange(model)}
                        sortingOrder={['asc', 'desc', null]}
                    />

                </Box>
            )}

            <Dialog open={openViewPdfDialog} onClose={handleCloseViewPdfDialog} maxWidth="md" fullWidth
                PaperProps={{
                    style: {
                        // overflow: 'hidden', // Remove scroll bar from the dialog box
                    },
                }}
            >
                <DialogContent style={dialogStyles}>
                    {pdf ? <div style={{ width: '100%', display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                        <Stack flexDirection="row" display="flex" justifyContent="space-between" alignItems="center" width="100%" >
                            <Tooltip title="Download" arrow>
                                <LoadingButton
                                    variant="contained"
                                    sx={{ boxShadow: 'none' }}
                                    onClick={() => downloadDefaultPdf()}
                                >
                                    <Download />
                                </LoadingButton>
                            </Tooltip>
                            {openLink && <Link variant="subtitle2" onClick={() => downloadAppPdf()}
                                sx={{
                                    cursor: 'pointer',
                                    color: 'primary.main',
                                    fontWeight: 'bold',
                                    textDecoration: 'none',
                                    '&:hover': { textDecoration: 'underline' }
                                }}>
                                Download app report
                            </Link>}
                            <Button onClick={handleCloseViewPdfDialog} variant="outlined" color="primary">
                                Close
                            </Button>
                        </Stack>
                        <div ref={documentRef} style={styles.documentBlock}>
                            {/* <TransformWrapper
                initialScale={1}
                smooth={true}
                wheel={{ step: 0.1, animationType: 'easeOut' }}
                pinch={{ step: 0.1, animationType: 'easeOut' }}
                doubleClick={{ step: 0.1, animationType: 'easeOut' }}
                onTransformed={(ref, scaleState) => {
                  handleZoom(scaleState?.scale)
                }} >
                <TransformComponent> */}
                            <Document
                                file={pdf}
                                onLoadSuccess={(data) => {
                                    setTotalPages(data.numPages);
                                }}
                                className={totalPages ? customStyle?.reactPdfDocument : null}
                            >
                                {Array.apply(null, Array(totalPages))
                                    .map((x, i) => i + 1)
                                    .map(page => <Page
                                        pageNumber={page}
                                        renderAnnotationLayer={false}
                                        renderTextLayer={false}
                                        width={750}
                                        scale={pdfScale}
                                    />)}
                            </Document>
                            {/* </TransformComponent>
              </TransformWrapper> */}
                        </div>
                    </div> : <div style={{ width: '100%', height: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}><CircularProgress /></div>}
                </DialogContent>
            </Dialog>
            <Dialog open={isDialogOpen} onClose={handleCloseDialog} disableScrollLock={false}>
                <DialogTitle style={{ textAlign: 'center' }}>Report Information</DialogTitle>

                <DialogContent>
                    {(selectedRowData && selectedRowData?.interpretation_data_logs && selectedRowData?.interpretation_data_logs?.length > 0) || (selectedRowData && selectedRowData?.meta_data) ? (

                        <List>
                            <ListItem sx={{ padding: 0 }}>
                                <ListItemText
                                    primary={<Typography variant="body1">
                                        <strong>Report ID:</strong> {selectedRowData?.id || '--'}
                                    </Typography>}
                                />
                            </ListItem>

                            <ListItem sx={{ padding: 0 }}>
                                <ListItemText
                                    primary={
                                        <Typography variant="body1">
                                            <strong>Report Type:</strong> {formatReportType(selectedRowData?.report_type)}
                                        </Typography>
                                    }
                                />

                            </ListItem>
                            <ListItem sx={{ padding: 0 }}>
                                <ListItemText
                                    primary={<Typography variant="body1"><strong>Device Name:</strong> {metaData.device_name || 'N/A'}</Typography>}
                                />
                            </ListItem>
                            <ListItem sx={{ padding: 0 }}>
                                <ListItemText
                                    primary={<Typography variant="body1"><strong>Device ID:</strong> {metaData.device_id || 'N/A'}</Typography>}
                                />
                            </ListItem>
                            <ListItem sx={{ padding: 0 }}>
                                <ListItemText
                                    primary={<Typography variant="body1">
                                        <strong>App Version:</strong> {metaData.app_version || 'N/A'}
                                    </Typography>}
                                />
                            </ListItem>
                            {selectedRowData?.business_name && <ListItem sx={{ padding: 0 }}><ListItemText
                                primary={<Typography variant="body1"><strong>Business Name:</strong> {selectedRowData?.business_name || '--'}</Typography>}
                            />
                            </ListItem>}
                            {selectedRowData?.interpretation_data_logs && selectedRowData?.interpretation_data_logs.length > 0 && (
                                <List>
                                    <ListItem sx={{ padding: 0 }}>
                                        <ListItemText
                                            primary={<Typography variant="body1">
                                                <strong>Interpretation History -:</strong>
                                            </Typography>}
                                        />
                                    </ListItem>
                                    {selectedRowData?.interpretation_data_logs?.map((item, index) => (
                                        <ListItem key={index} sx={{ padding: 0 }}>
                                            <ListItemText
                                                primary={item?.interpreter_details?.name}
                                                secondary={dayjs(item?.completed_at).format('DD MMM, YYYY hh:mm A')}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            )
                            }
                        </List>
                    ) : (
                        <Typography>No history available</Typography>
                    )}

                </DialogContent>

                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>

            </Dialog>
            <Dialog open={alertOpen} onClose={() => setAlertOpen(false)}>
                <DialogTitle> Report Already in Progress</DialogTitle>
                <DialogContent>
                    <Typography>
                        This report is already picked by:
                        <strong> {alertUser}</strong>.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setAlertOpen(false)} variant="contained">Okay</Button>
                </DialogActions>
            </Dialog>



        </>
    )
}